import React, { Component } from 'react';
import { Modal, Spin, Row, Col, Input, message, Button, Icon } from 'antd';
import DeleteContent from '../../../basicElement/DeleteContent';
import API_URL from '../../../../common/url';
import $ from '../../../../common/AjaxRequest';

class VisitStage extends Component {
    state = {
        visible: false,
        loading: false,
        data: {},
        stageList: [],
    }

    show = () => {
        this.setState({
            data: {},
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    loadData = () => {
        const { visitGroupingId } = this.props;
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.evaluate.queryVisitStageWithPeriod,
            data: { visitGroupingId },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    loading: false,
                    stageList: res.visitStageList || []
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        });
    }

    add = () => {
        const { visitGroupingId } = this.props;
        const { data } = this.state;
        if (!data.stageValue) {
            return message.warning('阶段名称不能为空!');
        }
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.evaluate.addVisitStage,
            data: { ...data, visitGroupingId },
            dataType: 'json',
            doneResult: (res) => {
                message.success(res.success);
                this.setState({
                    data: {},
                    loading: false,
                }, () => {
                    this.loadData();
                    this.props.updateCopyData();
                    this.props.queryStage();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        });
    }

    delete = params => {
        const { visitGroupingId } = this.props;
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.evaluate.delVisitStage,
            data: {
                ...params,
                visitGroupingId,
            },
            dataType: 'json',
            doneResult: (res) => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadData();
                    this.props.updateCopyData();
                    this.props.queryStage();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        });
    }

    handleChange = (value, key) => {
        const { data } = this.state;
        switch (key) {
            default:
                data[key] = value;
                break;
        }
        this.setState({ data });
    }

    getContent = () => {
        const { stageList } = this.state;
        return (
            <div>
                {
                    stageList.map(item => {
                        const { visitStageId, stageValue, visitPeriodList } = item;
                        if (visitPeriodList.length) {
                            return (
                                (item.visitPeriodList || []).map(i => {
                                    const { visitPeriodId, periodValue } = i;
                                    const content = `${stageValue}/${periodValue}`;
                                    return (
                                        <Row key={visitPeriodId} style={{minHeight: '30px'}}>
                                            <Col span={18} style={{backgroundColor:'#e5e5e5', textIndent: '.5em', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'}}>
                                                <span title={content}>{content}</span>
                                            </Col>
                                            <Col span={4} offset={2}>
                                                <Icon
                                                    type="close-circle"
                                                    style={{fontSize: 16, color: '#5750c9', cursor: 'pointer'}}
                                                    onClick={() => this.delete({ visitStageId, visitPeriodId })}
                                                />
                                            </Col>
                                        </Row>
                                    );
                                })
                            );
                        } else {
                            return (
                                <Row key={visitStageId} style={{minHeight: '30px'}}>
                                    <Col span={18} style={{backgroundColor:'#e5e5e5', textIndent: '.5em', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'}}>
                                        <span title={stageValue}>{stageValue}</span>
                                    </Col>
                                    <Col span={4} offset={2}>
                                        <Icon
                                            type="close-circle"
                                            style={{fontSize: 16, color: '#5750c9', cursor: 'pointer'}}
                                            onClick={() => this.delete({ visitStageId })}
                                        />
                                    </Col>
                                </Row>
                            );
                        }
                    })
                }
            </div>
        );
    }

    render() {
        const { visible, loading, data } = this.state;
        return (
            <Modal
                title="添加阶段/周期"
                visible={visible}
                onCancel={this.hide}
                cancelText='关闭'
                maskClosable={false}
                width="420px"
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <Spin spinning={loading}>
                    <div style={{ lineHeight: '40px' }}>
                        <Row>
                            <Col span={6} style={{textAlign: 'right'}}>
                                <span style={{color: 'red'}}>*</span>访视阶段：
                            </Col>
                            <Col span={10} offset={1}>
                                <Input
                                    placeholder='请输入'
                                    style={{ width: 160 }}
                                    value={data.stageValue}
                                    onChange={e => this.handleChange(e.target.value, 'stageValue')}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={6} style={{textAlign: 'right'}}>&nbsp;访视周期：</Col>
                            <Col span={10} offset={1}>
                                <Input
                                    placeholder='请输入'
                                    value={data.periodValue}
                                    onChange={e => this.handleChange(e.target.value, 'periodValue')}
                                />
                            </Col>
                            <Col span={6} offset={1}>
                                <Button type="primary" onClick={this.add}>添 加</Button>
                            </Col>
                        </Row>
                        <Row style={{paddingTop: 10, lineHeight: '24px', borderTop: "1px solid #ccc"}}>
                            <Col span={6}>已添加阶段/周期</Col>
                            <Col span={13} offset={1}>
                                { this.getContent() }
                            </Col>
                        </Row>
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default VisitStage;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/visitPeriodPlan/components/VisitStage.js